export default ($) => {
    function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';path=/;expires=' + expires.toUTCString();
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    function eraseCookie(key) {
        var keyValue = getCookie(key);
        setCookie(key, keyValue, '-1');
    }

    if( getCookie('warning_message') == null ) {
        console.log('show');
        $('#page-not-translated').removeClass( 'default-hide' ).addClass( 'show' );
        $('#page-not-translated .btn-close').on( 'click', function() {
            setCookie('warning_message',true,30)
        });
    }
    var element =  document.getElementById('q1-2023-msg');
    if (typeof(element) != 'undefined' && element != null) {
        element.addEventListener("click", function(event){
            let lang = document.getElementsByTagName('html')[0].getAttribute('lang')
            switch(lang) {
                // case 'fr-ca':
                //   window.location.href = "/fr-ca/hot-tub-sale";
                //   break;
                // case 'es-us':
                //   window.location.href = "/es-us/hot-tub-sale";
                //   break;
                default:
                  window.location.href = "/hot-tub-sale";
            }
            event.preventDefault();
        });
    }


    // if ($('#page-not-translated').hasClass('default-hide')) {
    //     $('#packet').click(function() {

    //         var events = [fireA, fireB];

    //         //declare counter
    //         if (!this.counter) {
    //             this.counter = 0;
    //         }

    //         events[this.counter]();
    //         this.counter = (this.counter + 1) % 3;
    //     });
    // }


    // $('#page-not-translated').one(() => {
    //     console.log(this);

    //     if( getCookie('warning_message') == null ) {
    //         console.log('show');
    //         console.log($( notification));
    //         $( notification ).removeClass( 'default-hide' );
    //     }
    //     // if ( $( notification ).hasClass( 'hide' ) ) {
    //     //     $( notification ).removeClass( 'hide' );
    //     //     $( notification ).addClass( 'show' );
    //     //   } else {
    //     //     $( notification ).removeClass( 'show' );
    //     //     $( notification ).addClass( 'hide' );
    //     //   }
    //     // console.log(indexSelect);
    //     // console.log($(select));
    //     // console.log(this);

    // })
}